import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "dialog-header" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "title-warning" }
const _hoisted_4 = { class: "demo-progress" }
const _hoisted_5 = { class: "percentage-value" }
const _hoisted_6 = { class: "percentage-label" }

import { computed, ref, watch, PropType, onUnmounted } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { exportOrderReport, getExportOrderReportInfo } from '@/api/operation'
import { ArrowDown, ArrowUp, Refresh } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectStation from '@/components/SelectStation.vue'
import SelectRemoteAdoUser from '@/components/SelectRemoteAdoUser.vue'
import { CommonState, ADOType } from '@/types/types'
import useProtocolEnums from '@/hooks/useProtocolEnums'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'CustomerReportingExport',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const showMoreQuery = ref(false)

const { getAdoTypeArray } = useProtocolEnums()

const { t } = useI18n()





const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      // 对话框关闭时清除定时器
      if (intervalId.value) {
        clearInterval(intervalId.value)
        intervalId.value = null
      }
    }
  },
})

const intervalId = ref<number | null>(null)
const maxRetryTime = 600000 // 10 分钟
const retryInterval = 3000 // 3 秒
const percentage = ref(0)

const id = ref<string>('')
const downloadUrl = ref<string>('')
const fuzzyParams = ref<Record<string, any>>({})

// 下载文件
const downloadFile = () => {
  if (downloadUrl.value) {
    isSubmitting.value = true // 开始加载

    // 创建一个隐藏的 <a> 标签
    const link = document.createElement('a')
    link.href = downloadUrl.value
    link.setAttribute('download', '') // 设置 download 属性（可选）
    document.body.appendChild(link)

    // 触发点击事件
    link.click()

    // 移除 <a> 标签
    document.body.removeChild(link)

    isSubmitting.value = false // 结束加载
  } else {
    console.error('Download URL is empty.')
  }
}

const loadInfo = async () => {
  try {
    if (!id.value) {
      return
    }

    isSubmitting.value = true
    const res = await getExportOrderReportInfo({ id: id.value })
    if (res.info.state == CommonState.CMS_FAIL || res.info.state == CommonState.CMS_CLOSE) {
      ElMessage.warning(t('Operation.genFail'))
      clearInterval(intervalId.value!)
      return
    }
    downloadUrl.value = res.info.filePath
    if (res.info.totalOrderNum <= 0) {
      percentage.value = 100
    } else {
      percentage.value = Math.floor((res.info.exportOrderNum / res.info.totalOrderNum) * 100)
    }
    if (percentage.value > 100) {
      percentage.value = 100
    }
    if (res.info.filePath) {
      clearInterval(intervalId.value!)
    }
  } catch (error) {
    console.log('getExportOrderReportInfo error:', error)
  } finally {
    isSubmitting.value = false
  }
}

const calculateDayDifference = (startDate: string, endDate: string): number => {
  const start = new Date(startDate).getTime()
  const end = new Date(endDate).getTime()
  const difference = end - start
  return Math.ceil(difference / (1000 * 60 * 60 * 24)) // 转换为天数
}

const genExport = async (retry: boolean) => {
  try {
    if (intervalId.value) {
      clearInterval(intervalId.value)
    }

    isSubmitting.value = true
    if (retry) {
      percentage.value = 0
    }

    if (!fuzzyParams.value.timeRange || fuzzyParams.value.timeRange.length !== 2) {
      ElMessage.warning(t('Base.rangeTimeFilterPlaceholder'))
      return
    } else {
      const dayDifference = calculateDayDifference(
        fuzzyParams.value.timeRange[0],
        fuzzyParams.value.timeRange[1],
      )
      console.log('dayDifference:', dayDifference)
      if (dayDifference > 31) {
        ElMessage.warning(t('Base.cusexportTip')) // 提示最多选择 31 天
        return
      }
    }





    if (fuzzyParams.value.stationID == '') {
      fuzzyParams.value.stationID = '0'
    }

    if (
      (!fuzzyParams.value.operatorID ||
        fuzzyParams.value.operatorID == '' ||
        fuzzyParams.value.operatorID == '0') && (!fuzzyParams.value.stationID ||
          fuzzyParams.value.stationID == '' ||
          fuzzyParams.value.stationID == '0')
    ) {
      ElMessage.warning(t('Operation.selectOperatorOrStation'))
      return
    }

    const res = await exportOrderReport({
      beginTime: fuzzyParams.value.timeRange[0],
      endTime: fuzzyParams.value.timeRange[1],
      operatorId: fuzzyParams.value.operatorID,
      stationId: fuzzyParams.value.stationID,
      userId: fuzzyParams.value.userId,
      groupId: fuzzyParams.value.groupId,
      retry: retry,
    })
    downloadUrl.value = res.url
    id.value = res.id

    if (!res.url) {
      intervalId.value = setInterval(() => {
        loadInfo()
      }, retryInterval) as unknown as number

      setTimeout(() => {
        if (intervalId.value) {
          clearInterval(intervalId.value)
          intervalId.value = null
          console.log('Retry stopped after 1 minute.')
        }
      }, maxRetryTime)
    } else {
      percentage.value = 100
    }
  } catch (error) {
    console.log('getExportOrderReportInfo error:', error)
  } finally {
    isSubmitting.value = false
  }
}

// 监听 showDialog 的变化
watch(showDialog, (newVal) => {
  if (!newVal && intervalId.value) {
    // 对话框关闭时清除定时器
    clearInterval(intervalId.value)
    intervalId.value = null
  }
})

onUnmounted(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "60%",
    class: "upsert-dialog",
    title: _ctx.$t('Base.export'),
    "z-index": 2000
  }, {
    header: _withCtx(({ titleId, titleClass }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, _toDisplayString(_unref(t)('Base.export')), 11, _hoisted_2),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('Base.cusexportTip')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "search-wrapper",
        onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (genExport(true)), ["enter"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: fuzzyParams.value.timeRange,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.timeRange) = $event)),
                    type: "daterange",
                    "range-separator": "-",
                    "value-format": "YYYY-MM-DD",
                    "start-placeholder": _unref(t)('Base.beginTime'),
                    "end-placeholder": _unref(t)('Base.endTime')
                  }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
                ]),
                _: 1
              }, 16),
              _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                default: _withCtx(() => [
                  _createVNode(SelectOperator, {
                    modelValue: fuzzyParams.value.operatorID,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.operatorID) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 16),
              _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                default: _withCtx(() => [
                  _createVNode(SelectStation, {
                    modelValue: fuzzyParams.value.stationID,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.stationID) = $event)),
                    operatorID: fuzzyParams.value.operatorID
                  }, null, 8, ["modelValue", "operatorID"])
                ]),
                _: 1
              }, 16),
              (showMoreQuery.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: fuzzyParams.value.ado,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.ado) = $event)),
                          clearable: "",
                          prop: "operationType"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdoTypeArray)([_unref(ADOType).ADOT_USER, _unref(ADOType).ADOT_GROUP]), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.label,
                                value: item.value,
                                key: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 16),
                    (fuzzyParams.value.ado == _unref(ADOType).ADOT_GROUP)
                      ? (_openBlock(), _createBlock(_component_el_col, _normalizeProps(_mergeProps({ key: 0 }, _unref(colProps))), {
                          default: _withCtx(() => [
                            _createVNode(SelectRemoteAdoUser, {
                              modelValue: fuzzyParams.value.groupId,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fuzzyParams.value.groupId) = $event)),
                              operatorId: fuzzyParams.value.operatorID,
                              ado: fuzzyParams.value.ado,
                              disabled: fuzzyParams.value.operatorID == '0' ||
                fuzzyParams.value.operatorID == '' ||
                fuzzyParams.value.operatorID == undefined
                
                            }, null, 8, ["modelValue", "operatorId", "ado", "disabled"])
                          ]),
                          _: 1
                        }, 16))
                      : _createCommentVNode("", true),
                    (fuzzyParams.value.ado == _unref(ADOType).ADOT_USER)
                      ? (_openBlock(), _createBlock(_component_el_col, _normalizeProps(_mergeProps({ key: 1 }, _unref(colProps))), {
                          default: _withCtx(() => [
                            _createVNode(SelectRemoteAdoUser, {
                              modelValue: fuzzyParams.value.userId,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fuzzyParams.value.userId) = $event)),
                              operatorId: fuzzyParams.value.operatorID,
                              ado: fuzzyParams.value.ado,
                              minSearchKeyLen: 5,
                              disabled: fuzzyParams.value.operatorID == '0' ||
                fuzzyParams.value.operatorID == '' ||
                fuzzyParams.value.operatorID == undefined
                
                            }, null, 8, ["modelValue", "operatorId", "ado", "disabled"])
                          ]),
                          _: 1
                        }, 16))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper flex-content" }), {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    plain: "",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (genExport(true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.generate')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: downloadFile,
                    disabled: !_ctx.$hasPermission('post') || !downloadUrl.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.download')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_tooltip, {
                    content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "icon-button",
                        plain: "",
                        icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "icon-button",
          plain: "",
          icon: _unref(Refresh),
          onClick: loadInfo
        }, null, 8, ["icon"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_progress, {
            type: "dashboard",
            percentage: percentage.value
          }, {
            default: _withCtx(({ percentage }) => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(percentage) + "%", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(percentage >= 100 ? _unref(t)('Base.done') : _unref(t)('Base.gening')), 1)
            ]),
            _: 1
          }, 8, ["percentage"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})